import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.5 16.125H9.375a.864.864 0 0 1-.875-.875c0-.465.383-.875.875-.875h3.992L7.871 8.879a.843.843 0 0 1 0-1.23.843.843 0 0 1 1.23 0l5.524 5.496v-4.02c0-.465.383-.875.875-.875a.9.9 0 0 1 .875.875v6.125c0 .492-.41.875-.875.875"
    }, null, -1)
  ]))]))
}
export default { render: render }